import { ZAttrItemProps } from "src/common/attrEdit";
import { edAttrField } from "src/pages/ManagementPage/Obj2Tab/EdAttribute";
import { ZIdName } from "src/types/ZIdName";
import { ZUid } from "src/types/zUid";

const root = edAttrField.editorInfo;
export const edCompField = (name: string) => [root, "component", name];
export const edItemField = (name: keyof ZAttrItemProps) => [
  root,
  "itemProps",
  name,
];
export const editorField = edCompField("editor");

export type ParamsEditorInfo2 = {
  attrTypesDict: Record<number, string>;
  disabled: boolean;
  objectId: ZUid;
  curAttrId: ZUid;
  loadObjectOptions(): Promise<ZIdName[]>;
};
